<template>
  <Loading v-if="isLoading" :loadingText="'Carregando...'"></Loading>
  <div v-else class="content-lincar-user d-flex align-items-center">
    <b-container fluid="lg">
      <header class="border-bottom border-light py-3">
        <div class="d-flex align-items-center justify-content-between">
            <h4>Vincular Usuário</h4>
            <div class="help" v-b-tooltip.hover title="Clique no botão cadastrar, selecione a escola ao qual pertence o usuário, em turma selecione a turma e clique em ações.">
              <i class="far fa-circle-question"></i> Ajuda
            </div>
          </div>
      </header>
      <b-form @submit.prevent="postData" class="my-4">
            <b-form-row>
              <b-col cols="12" md="6" lg="6" xl="6">
                <b-form-group 
                  label="Selecionar Usuário:"
                  label-for="select-user"
                  label-class="my-1"
                >
                  <div class="position-relative">
                    <b-form-input
                      id="autocomplete-user"
                      v-model="search"
                      @focus="showDropdown = true"
                      @input="filterUsers"
                      placeholder="Digite o nome do usuário"
                      autocomplete="off"
                    ></b-form-input>

                    <!-- Dropdown -->
                    <ul flush v-if="showDropdown && filteredUsers.length" class="autocomplete-dropdown">
                      <li 
                        v-for="user in filteredUsers" 
                        :key="user.id"
                        class="dropdown-item border-0 p-2"
                        debounce="500"
                        @mousedown.prevent="selectUser(user)"
                      >
                        {{ user.name }}
                      </li>
                    </ul>
                  </div>
                  <!-- <b-form-select
                    id="select-user"
                    v-model="selectedUser"
                    :options="userOptions"
                    @input="onUserSelected"
                  >
                    <template v-slot:first>
                      <option value="" disabled>Selecione o usuário ou digite para buscar.</option>
                    </template>
                  </b-form-select> -->
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" lg="6" xl="6">
                <b-form-group 
                  label="Login Super Pro:"
                  label-for="input-login-user"
                  label-class="my-1"
                >
                  <b-form-input
                    id="input-login-user"
                    v-model="form.user_super_pro"
                    placeholder="Digite o usuário do Super Pro"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" lg="6" xl="6">
                <b-form-group 
                  label="Senha Super Pro:"
                  label-for="password-super-pro"
                  label-class="my-1"
                >
                <b-form-input
                  id="password-super-pro"
                  type="password"
                  v-model="form.password_super_pro"
                  placeholder="Digite a senha"
                  required
                ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" lg="6" xl="6">
                <b-form-group 
                  label="Habilitar usuário?"
                  label-for="password-super-pro"
                  label-class="my-1"
                >
                  <b-form-select
                    id="habilita-select"
                    v-model="form.habilita"
                    :options="[
                      { value: true, text: 'Sim' },
                      { value: false, text: 'Não' }
                    ]"
                    required
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <div class="d-block d-md-flex justify-content-center justify-content-md-end">
              <b-button type="submit" class="btn-vinculo order-md-2"><i class="far fa-circle-plus fa-sm"></i> Vincular</b-button>
              <b-button :to="{ name: 'schools' }" class="mr-2 btn-new-user order-md-1">Cadastrar Usuário</b-button>
            </div>
          </b-form>
    </b-container>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import Loading from '@/components/loading.vue';
import Multiselect from 'vue-multiselect';
/* import 'vue-multiselect/dist/vue-multiselect.min.css'; */

export default {
  name: 'vincular-usuario',
  components: {
    /* Multiselect */
    Loading
  },
  data() {
    return {
      search: '',
      selectedUser: '',
      objectSpw: {
        data: {
          user: []
        }
      },
      filteredUsers: [],
      form: {
        user_sistemacpv: null,
        user_super_pro: '',
        password_super_pro: '',
        habilita: true
      },
      showDropdown: false,
      isLoading: true,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    setTimeout(() => {
      this.isLoading = false
    }, 1000)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    userOptions() {
      return this.filteredUsers.map(user => ({
        value: user.id,
        text: user.name
      }));
    }
  },
  created() {
    this.$emit('update-header', {
      title: 'Vincular Usuário',
      subtitle: ''
    });
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      try {
        const response = await ApiService.post('v1/spw');
        this.objectSpw = response;
        this.filteredUsers = response.data.user;
      } catch (error) {
        console.error('Erro ao carregar usuários:', error);
      }
    },
    filterUsers() {
      const searchTerm = this.search.toLowerCase();
      this.filteredUsers = this.objectSpw.data.user.filter(user =>
        user.name.toLowerCase().includes(searchTerm)
      );
    },
    onUserSelected(user) {
      this.form.user_sistemacpv = user?.id ?? null;
    },
    async postData() {
      try {
        const payload = {
          ...this.form,
          record: true
        };
        await ApiService.post('v1/spw', payload);
        this.$bvToast.toast('Usuário vinculado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        });
        await this.loadUsers();
        this.resetForm();
      } catch (error) {
        console.error('Erro ao vincular usuário:', error);
        this.$bvToast.toast('Erro ao vincular usuário', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        });
      }
    },
    resetForm() {
      this.search = '';
      this.selectedUser = null;
      this.form = {
        user_sistemacpv: null,
        user_super_pro: '',
        password_super_pro: '',
        habilita: true
      };
      this.filteredUsers = this.objectSpw?.data?.user || [];
    },

    // bruno teste aqui
    selectUser(user) {
      this.selectedUser = user.id;
      this.search = user.name;
      this.form.user_sistemacpv = user?.id ?? null;
      this.showDropdown = false;
    },

    handleClickOutside(event) {
      // Verifica se o clique foi fora do input ou do dropdown
      const dropdown = this.$el.querySelector('.position-relative');
      const input = this.$el.querySelector('#autocomplete-user');

      if (dropdown && !dropdown.contains(event.target)) {
        this.showDropdown = false;
      }
    },
  }
};
</script>

<style scoped>
/* .content-lincar-user {
  background-color: #f6f6f6;
  height: calc(100vh - 214px);
} */

.content-lincar-user h4 {
  margin-bottom: 0;
}

.help {
  color: #805dca;
  font-style: italic;
  font-weight: 600;
}

.btn-vinculo, .btn-new-user {
  padding: 8px 16px;
  border: 1px solid #805dca;
  color: #805dca !important;
  font-weight: 300;
  background-image: none;
  background: linear-gradient(90deg, #805dca 0%, #805dca 50%, transparent 50%, transparent 100%);
  background-size: 200% 100%;
  background-position: right;
  transition: background 0.5s ease, color 0.5s ease, border 0.5s ease;
  box-shadow: none;
}

.btn-vinculo:hover, .btn-new-user:hover{
  background-position: left;
  border-color: #805dca;
  background-color: transparent;
}

.btn-vinculo:focus, .btn-new-user:focus {
  background-color: #805dca;
  box-shadow: none;
  border-color: #805dca !important;
  color: #805dca;
}

.autocomplete-dropdown {
  max-height: 300px;
  overflow: auto;
  position: absolute;
  z-index: 999;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
}

@media only screen
  and (max-width: 768px) {
    .btn-vinculo, .btn-new-user {
      width: 100%;
      margin: 5px 0;
    }
  }
</style>